import { faBug, faCircleExclamation, faThumbsUp } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Button, Typography } from "@mui/material"
import { translate } from "app/language/service"
import { IRootState } from "app/model"
import { FORGOT_PASSWORD_PATH, LOGIN_PATH } from "page/model"
import { navigate } from "page/tools/navigate"
import React, { useEffect } from "react"
import { connect } from "react-redux"
import { FlexBox } from "ui/components/FlexBox"
import { LinearLoader } from "ui/components/LinearLoader"
import { ISignUpUserForm, SIGNUP_STATUS } from "user/model"
import { clearSignUpWizard, clearSignUpWizardStatus } from "user/tools/signup"
import { SignUpWizardContent } from "./SignUpWizardContent"
import { SignUpWizardProgressHeader } from "./SignUpWizardProgressHeader"

interface ISignUpWizardProps {
  userForm: ISignUpUserForm
  status: SIGNUP_STATUS
}

const SignUpWizardFn = React.memo(({ status, userForm }: ISignUpWizardProps) => {
  useEffect(() => clearSignUpWizard, [])
  return (
    <FlexBox
      vertical
      jc="start"
      fullWidth
      sx={{ "height": "calc(100% - 5rem)", "maxHeight": "calc(100% - 5rem)", "& > *": { width: "100%" } }}>
      {status === SIGNUP_STATUS.ERROR_ALREADY_EXIST ? (
        <FlexBox vertical gap sx={{ p: "2rem" }}>
          <FlexBox gap sx={{ "& .icon": { color: theme => theme.palette.primary.main } }}>
            <FontAwesomeIcon icon={faCircleExclamation} size="3x" className="icon" />
            <Typography color="error">{translate("user.signup.error.exist")}</Typography>
          </FlexBox>
          <Button
            onClick={() => navigate({ path: FORGOT_PASSWORD_PATH, hashParams: [["email", userForm.data.email]] })}
            variant="contained">
            {translate("user.password.forgotten")}
          </Button>
        </FlexBox>
      ) : status === SIGNUP_STATUS.ERROR ? (
        <FlexBox vertical gap sx={{ p: "2rem" }}>
          <FlexBox gap sx={{ "& .icon": { color: theme => theme.palette.primary.main } }}>
            <FontAwesomeIcon icon={faBug} size="3x" className="icon" />
            <Typography color="error">{translate("user.signup.error")}</Typography>
          </FlexBox>
          <Button onClick={clearSignUpWizardStatus} variant="contained">
            {translate("user.signup.try.again")}
          </Button>
        </FlexBox>
      ) : status === SIGNUP_STATUS.SUCCESS ? (
        <FlexBox vertical gap sx={{ p: "2rem" }}>
          <FlexBox gap sx={{ "& .icon": { color: theme => theme.palette.primary.main } }}>
            <FontAwesomeIcon icon={faThumbsUp} size="3x" className="icon" />
            <Typography id="signup-success-message" color="textPrimary">
              {translate("user.signup.success")}
            </Typography>
          </FlexBox>
          <Button onClick={() => navigate(LOGIN_PATH)} variant="contained">
            {translate("login.title")}
          </Button>
        </FlexBox>
      ) : status === SIGNUP_STATUS.REQUESTING ? (
        <LinearLoader />
      ) : (
        <>
          <SignUpWizardProgressHeader />
          <SignUpWizardContent />
        </>
      )}
    </FlexBox>
  )
})

export const SignUpWizard = connect(
  (state: IRootState): ISignUpWizardProps => ({
    status: state.user.signup.status,
    userForm: state.user.signup.userForm
  })
)(SignUpWizardFn)
